export function getData(data, key) {
  if (key === "read") {
    return data.filter((_el) => _el.status === key);
  } else if (key === "unread") {
    return data.filter((_el) => _el.status === key);
  } else {
    return data;
  }
}
